import { render, staticRenderFns } from "./CreateAutoRent2.vue?vue&type=template&id=fb0cddce&"
import script from "./CreateAutoRent2.vue?vue&type=script&lang=js&"
export * from "./CreateAutoRent2.vue?vue&type=script&lang=js&"
import style0 from "./CreateAutoRent2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateAutoRent2.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VDatePicker,
  VFlex,
  VLayout,
})
